import {
  Breadcrumb,
  Button,
  Card,
  Checkbox,
  Col,
  Form,
  Input,
  Row,
  Select,
  Typography,
} from 'antd';

import React from 'react';
import { IoMailOutline } from 'react-icons/io5';
import ReactInputMask from 'react-input-mask';
import { Link } from 'react-router-dom';

class WebContact extends React.Component {
  breadcrumb = [
    {
      title: (
        <Link to="/">
          <Typography className="home-breadcrumb-link">Home</Typography>
        </Link>
      ),
    },
    {
      title: (
        <Typography className="home-breadcrumb-link active">Contato</Typography>
      ),
    },
  ];

  render = () => {
    return (
      <Row>
        <Col className="home-col-black" span={24}>
          <Row align={'middle'} className="home-row-breadcrumb">
            <Col span={12}>
              <Breadcrumb className="home-breadcrumb" items={this.breadcrumb} />
            </Col>
            <Col span={12}>
              <Typography className="home-breadcrumb-title">Contato</Typography>
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Row className="home-row-page" gutter={[20, 16]}>
            <Col span={24}>
              <Typography className="home-row-page-text-title">
                CONTATO
              </Typography>
            </Col>
            <Col span={24}>
              <Typography className="home-row-page-text">
                Dúvida ou sugestão? Entre em contato conosco.
              </Typography>
            </Col>
            <Col md={12} xs={24}>
              <Card hoverable style={{ marginTop: 20 }}>
                <div className="contact-div">
                  <div className="contact-icon">
                    <IoMailOutline color="var(--primary)" size={30} />
                  </div>
                  <Typography className="home-row-page-text">
                    <b>Se preferir pode mandar um e-mail!</b>
                  </Typography>
                  <Typography className="home-row-page-text">
                    info@example.com
                  </Typography>
                  <Typography className="home-row-page-text">
                    contact@example.com
                  </Typography>
                </div>
              </Card>
            </Col>
            <Col md={12} xs={24}>
              <Card hoverable style={{ height: 483 }}>
                <Form>
                  <Form.Item>
                    <Input placeholder="Seu nome" size="large" type="text" />
                  </Form.Item>
                  <Form.Item>
                    <Input
                      placeholder="Seu melhor e-mail"
                      size="large"
                      type="text"
                    />
                  </Form.Item>
                  <Form.Item>
                    <ReactInputMask
                      mask="(99) 99999-9999"
                      placeholder="Seu melhor celular"
                      type="text"
                    >
                      {(props) => <Input {...props} />}
                    </ReactInputMask>
                  </Form.Item>
                  <Form.Item>
                    <Select placeholder="Assunto" size="large">
                      <Select.Option value="duvidas">Dúvidas</Select.Option>
                      <Select.Option value="sugestoes">Sugestões</Select.Option>
                      <Select.Option value="suporte">Suporte</Select.Option>
                      <Select.Option value="reclamacao">
                        Reclamação
                      </Select.Option>
                      <Select.Option value="parceria">Parceria</Select.Option>
                      <Select.Option value="vendas">Vendas</Select.Option>
                    </Select>
                  </Form.Item>
                  <Form.Item>
                    <Input.TextArea
                      autoSize={false}
                      placeholder="Como podemos ajudar?"
                      rows={3}
                      size="large"
                      style={{ resize: 'none' }}
                      type="text"
                    />
                  </Form.Item>
                  <Form.Item>
                    <Checkbox>
                      Autorizo o contato e armazenamento dos meus dados para
                      outros contatos e estou ciente que o objetivo desse
                      formulário é para contato telefônico e/ou envio de e-mail.
                    </Checkbox>
                  </Form.Item>
                  <Form.Item>
                    <center>
                      <Button
                        className="btn-primary"
                        size="large"
                        type="primary"
                      >
                        Enviar
                      </Button>
                    </center>
                  </Form.Item>
                </Form>
              </Card>
            </Col>
          </Row>
        </Col>
      </Row>
    );
  };
}

export default WebContact;
